<div class="jumbotron">
	<div class="centered-text" *ngIf="!saving">Na <b>{{data.details.group.cases.length}}</b> případech budou vygenerovány podle šablony s názvem <b>{{data.details.group.template.name}}</b> dokumenty typu <b>{{data.details.group.document.name}}</b>.</div>
	<div class="centered-text" *ngIf="saving">
		<b>{{processed}}/{{data.details.group.cases.length}}</b>
		<div [loading]="true"></div>
	</div>
</div>
